import { isLegacyLevelDatum } from "building-types/datums/datumEntityTypes";
import type { Doc } from "building-types/doc";
import type { DocRefEligibleEntityHandle } from "building-types/entities/docRefEligibleEntityTypes";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import { isDocRefDirectEligibleHandle, isDocRefIndirectEligibleHandle } from "./docRefEligibleEntityTypeTools";
import { docEntityIsSystemEntity } from "./docSystemEntity";

export function docEntityIsDocRefEligible(doc: Doc, handle: DocEntityHandle): handle is DocRefEligibleEntityHandle {
  if (docEntityIsSystemEntity(doc, handle)) {
    return false;
  }

  if (!docEntityDocRefEligibleFilter(doc, handle)) {
    return false;
  }

  if (isDocRefDirectEligibleHandle(handle)) {
    return true;
  }

  return isDocRefIndirectEligibleHandle(handle);
}

function docEntityDocRefEligibleFilter(doc: Doc, handle: DocEntityHandle): boolean {
  switch (handle.type) {
    case "DATUM": {
      // Level datums are not doc ref eligible since we don't have the same levels in the target doc
      const datum = doc.datums[handle.id];
      return !!datum && !isLegacyLevelDatum(datum);
    }
    default:
      return true;
  }
}
